export default class CloseModal {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.modal.remove();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/modal/close_modal.js